import React, {useState} from "react";
import { Box, Button, Column, Columns, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import {useDispatch, useSelector} from "react-redux";
import {
    getDataFresh, getInvoicesData, getPartOrderData, getNominalCodesData, getTrackingOptionsData, getDepartmentsData,
    getRentalData, getInvoiceFiguresData
} from "../../../state/selectors";
import InvoiceRow from "./InvoiceRow";
import {useInvoicesData} from "../../../hooks/useInvoicesData";
import LoadingSpinner from "../../Utils/Spinner";
import {
    createSetDataFreshAction,
    createSetInvoicesDataAction,
    createSetPartOrderData, createSetRentalAction
} from "../../../actions/dataActions";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import SearchBar from "../../Utils/SearchBar";
import useSelect from "../../../hooks/useSelect";
import FilterBlankHeading from "../../Invoicing/FilterBlankHeading";
import FilterHeading from "../../Invoicing/FilterHeading";
import CreateCreditNoteModal from "../../Credit Note/CreateCreditNoteModal";
import {useNominalCodesData} from "../../../hooks/useNominalCodesData";
import {formatXeroData, sendXeroData} from "../../../utils";
import {useTrackingOptionsData} from "../../../hooks/useTrackingOptionsData";
import {useDepartmentsData} from "../../../hooks/useDepartmentsData";
import PartListModal from "./PartListModal";
import BlankDepartmentSelector from "../../Utils/BlankDepartmentSelector";
import ApprovalModal from "./ApprovalModal";
import RentalInfoModal from "./RentalInfoModal";
import {useInvoiceFiguresData} from "../../../hooks/useInvoiceFiguresData";
import FiguresDisplay from "./FiguresDisplay";
import useInput from "../../../hooks/useInput";
import Nav from "../../Nav/Nav";
import {useSearchParams} from "react-router-dom";
import PaginationWrapper from "../../Utils/PaginationWrapper";



export default function InvoiceView(props){
    let [page, setPage] = useState(1);
    const [searchText , setSearchText] = useState();
    const [currentSearch, setCurrentSearch] = useState();
    const [selectedDepartment, setSelectedDepartment] = useState(-1);
    const [partListModalOpen, setPartListModalOpen] = useState(false);
    const [selected, setSelected] = useState({});
    const [approvalModalOpen, setApprovalModalOpen] = useState(false);

    let [searchParams, setSearchParams] = useSearchParams();

    const [filters, setFilters] = useState({});
    const [selectedInvoice, setSelectedInvoice] = useState();
    const [creditModalOpen, setCreditModalOpen] = useState(false);
    const [detailModalOpen, setDetailModalOpen] = useState(false);

    const [startDate, startDateInput] = useInput({
        type: "date",
        label: "Start Date",
    });
    const [endDate, endDateInput] = useInput({
        type: "date",
        label: "End Date",
    });


    const onSelectCheck = item => {
        let newSelection = { ...selected };
        if (Object.keys(selected).indexOf(item.id.toString()) === -1) {
          newSelection[item.id.toString()] = item;
        } else {
          delete newSelection[item.id.toString()];
        }
        setSelected(newSelection);
    };

    const toggleSelectVisible = () => {
        let newSelected = { ...selected };
        let selectedKeys = Object.keys(newSelected);
        const notPresent = data.results.find(
          part => selectedKeys.indexOf(part.id.toString()) === -1
        );

        if (notPresent) {
          data.results.forEach(item => {
            newSelected[item.id.toString()] = item;
          });
        } else {
          data.results.forEach(item => {
            delete newSelected[item.id.toString()];
          });
        }
        setSelected(newSelected);
    };

    const clearSelected = () => {
        setSelected({});
    };

    let activeView = searchParams.get("activeView");

    let params = {page: page, activeView};
    const viewOptions = [
        {name:"All", value: "all"},
        {name:"Approved", value:"approved"},
        {name:"Ready to Invoice", value:"ready"},
        {name:"Not Approved", value:"not_approved"},
        {name: "Hidden", value: "hide"}
    ]
    const [view, viewInput] = useSelect({
        label:"View",
        initialValue: "not_approved",
        options: viewOptions
    });
    if(view){
        params.view = view;
    }
    if(startDate){
        params.start_date=startDate
    }
    if(endDate){
        params.end_date=endDate
    }
    if(selectedDepartment){
        params.department = selectedDepartment
    }
    if(currentSearch){
        params.search = currentSearch;
    }
    for (let filter in filters) {
        if (filters[filter][0] && filters[filter][0][filter]) {
          params[filter] = filters[filter][0][filter];
        }
    }

    let dataFresh = useSelector(getDataFresh);
    let loaded = useInvoicesData(params, dataFresh);
    let figuresLoaded = useInvoiceFiguresData(params, dataFresh);
    let codesLoaded = useNominalCodesData({page_size: 1000}, dataFresh);
    let trackingOptionsLoaded = useTrackingOptionsData({page_size: 1000}, dataFresh);


    let departmentsLoaded = useDepartmentsData({}, dataFresh);
    let data = useSelector(getInvoicesData);
    let figureData = useSelector(getInvoiceFiguresData);
    let selectedPartOrder = useSelector(getPartOrderData);
    let selectedRental = useSelector(getRentalData);
    let departments = useSelector(getDepartmentsData);
    let codes = useSelector(getNominalCodesData);
    let trackingOptions = useSelector(getTrackingOptionsData);
    let rental = useSelector(getRentalData);
    const dispatch = useDispatch();

    const headings = [
        {
            label: "Invoice ID",
            show: true
        },
        {
            label: "Movement ID",
            show: activeView === "movement"
        },
        {
            label: "Date",
            show: false //activeView === "hire"
        },
        {
            label: "Customer",
            field: "customer",
            labelField: "customer__display_name",
            show: true
        },
        // {
        //     label: "Type",
        //     show: true
        // },
        {
            label: "Quantity",
            show: activeView === "hire"
        },
        {
            label: "Vatable Amount",
            show: true
        },
        {
            label: "Non Vatable Amount",
            show: true
        },
        {
            label: "VAT",
            show: true
        },
        {
            label: "Total Amount",
            show: true
        },
        {
            label: "Invoice Date",
            field: "invoice_date",
            labelField: "invoice_date",
            show: true
        },
        {
            label: "Date Paid",
            show: false //do not know if date paid is needed anymore
        },
        {
            label: "Account",
            show: activeView === "movement"
        },
        {
            label: "Tracking Category",
            show: true
        },
        {
          label: "VAT Nominal Code",
          show: true
        },
        {
            label: "No VAT Nominal",
            show: true
        },
        {
            label: "Invoice Number",
            blank: true,
            field: "invoice_number",
            show: true
        },
        {
            label: "Customer Paid",
            show: activeView === "movement" || activeView === "order"
        },
        {
            label: "Description",
            show: true
        },
        {
            label: "Comments",
            show: true
        },
        {
            label: "Approver",
            field: "approver",
            labelField: "approver__first_name",
            show: view === "approved"
        },
        {
          label: "",
          show: true
        }
    ]



    if (!loaded || !departmentsLoaded|| !codesLoaded || !trackingOptionsLoaded){
        return (
            <div>
                <Nav/>
                <LoadingSpinner/>
            </div>
        )
    }

    const codeObjects = codes ? codes.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
    }, {}) : {};

    const trackingOptionObjects = trackingOptions ? trackingOptions.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
    }, {}) : {};




    const onChange = (e, index) => {
        let newResults = [...data.results];
        let newData = {...data, results: newResults};
        let newInvoice = {...data.results[index], [e.target.name] : e.target.value}
        newData.results[index] = newInvoice;
        dispatch(createSetInvoicesDataAction(newData));
    };

    const onHireView = (index) => {
        let targetInvoice = data.results[index];
        if(targetInvoice.rental){
            const conf = {
                url: props.endpoint+`rentals/${targetInvoice.rental.id}`,
                method: "get"
            };
            axios(conf).then(res => {
                dispatch(createSetRentalAction(res.data));
                setDetailModalOpen(true);
            })
        }
    }


    const onPartView = (index) => {
        let targetInvoice = data.results[index];
        if(targetInvoice.part_order){
            const conf = {
                url: props.endpoint+`partorder/${targetInvoice.part_order.id}`,
                method: "get"
            };
            axios(conf).then(res => {
                dispatch(createSetPartOrderData(res.data));
                setPartListModalOpen(true);
            })
        }
    }

    const onNominalChange = (e, index) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: codeObjects[e.target.value]
            }
        };
        onChange(toUpdate, index)
    }

    const onTrackingOptionChange = (e, index) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: trackingOptionObjects[e.target.value]
            }
        };
        onChange(toUpdate, index)
    }

    const onSave = (data) => {
        const conf = {
            url: props.endpoint+"invoices/"+data.id,
            method: "put",
            data: data
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(()=> {
            toast.error("There was an error saving the invoice", {position: "top-right"})
        })
    };

    const onHide = (data, hide) => {
        let newData = {...data, hide:hide}
        const conf = {
            url: props.endpoint+"invoices/hide",
            method: "put",
            data: newData
        }
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error hiding that invoice", {position: "top-right"})
        })
    }

    const onDelete = (data) => {
        const conf = {
            url: props.endpoint+"invoices/"+data.id,
            method: "delete"
        }
        axios(conf).then((res) => {
            dispatch(createSetDataFreshAction(dataFresh+1));
        }).catch(() => {
            toast.error("There was an error deleting that movement", {position: "top-right"});
        })
    };
    const validator = data => {
        if(data.customer.partial_contact){
            toast.warning("The customer must be fully setup", {position: "top-right"})
            return false
        }
        else {
            let valid = true;
            if(data.amount > 0){
                if(data.vat_nominal_code && data.vat_nominal_code.id){
                    valid = true
                }
                else{
                    valid = false
                }
            }
            if(data.no_vat_amount > 0){
                if(data.no_vat_nominal_code && data.no_vat_nominal_code.id){
                    valid = true
                }
                else{
                    valid = false
                }
            }
            valid = valid && !!data.invoice_date
            if(valid === false){
                toast.warning("Invoice Date and Nominal Codes are required", {position: "top-right"});
            }
            return valid
        }
    }
    const multiValidator = data => {
        let valid = true
        data.forEach(invoice => {
            valid = valid && validator(invoice)
        });
        return valid
    }

    const validMultiSelect = data => {
        // takes an array on invoices
        // if all invoices have the same customer
        // return true

        let targetCustomer = data[0].customer
        let validCount = data.filter(invoice => invoice.customer.id === targetCustomer.id);

        return data.length === validCount.length
    }

    const onApprove = (data) => {
        // takes an array of invoices
        if(!validMultiSelect(data)){
            toast.error("Selected Invoices do not have the same customer", {position: "top-right"})
            return
        }
        if(multiValidator(data)) {
            const conf = {
                url: props.endpoint + "invoiceapprove",
                method: "put",
                data: data
            };
            axios(conf).then(res => {
                clearSelected();
                let invoice = formatXeroData(res.data, "IN");
                console.log(invoice);
                if(invoice.XeroDept) {
                    sendXeroData(invoice, "SalesInvoice").then(res => {
                        toast.success("All data has been sent to xero", {position: "top-right"})
                    }).catch(err => {
                        toast.error("There was an error sending", {position: "top-right"})
                    })
                }
                dispatch(createSetDataFreshAction(dataFresh + 1))
            }).catch(err => {
                console.log(err);
            })
        }
    }

    const onReady = (data) => {
        // expects an array of data
        const conf = {
            url: props.endpoint+"invoiceready",
            method: "put",
            data: data
        };
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
            clearSelected();
        }).catch(() => {
            toast.error("There was an error", {position: "top-right"})
        })
    }

    const handleSearch = () => {
        setPage(1);
        setCurrentSearch(searchText);
    };

    const clear = () => {
        setSearchText("");
        setCurrentSearch("");
        setPage(1);
    };

    const onDepartmentChange = e => {
        setSelectedDepartment(e.target.value);
    }

    document.title = "Invoicing";
    // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
    return (
        <div>
            <Nav/>
            <br/>
            <br/>
            <Box>
                <Columns isMultiline>
                    <Column>
                        <Title>Invoicing</Title>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <label className="label">Search</label>
                        <SearchBar
                            searchText={searchText}
                            setSearchText={setSearchText}
                            handleSearch={handleSearch}
                            clear={clear}
                        />
                    </Column>
                    <Column>
                        <BlankDepartmentSelector
                            selectedDepartment={selectedDepartment}
                            departments={departments}
                            onDepartmentChange={onDepartmentChange}
                        />
                    </Column>
                    <Column>
                        {viewInput}
                    </Column>
                    {startDateInput}
                    {endDateInput}
                </Columns>
            </Box>
            <FiguresDisplay figuresData={figureData} figuresLoaded={figuresLoaded}/>
            <Box>
                <Columns isMultiline>
                 <Column>
                     <Table isFullwidth>
                         <thead>
                            <tr>
                                {headings.map(heading => {
                                    if (!heading.field && heading.show) {
                                      return <th className={heading.className} key={heading.label}>{heading.label}</th>;
                                    }
                                    if (heading.blank) {
                                      return (
                                        <FilterBlankHeading
                                          key={heading.label}
                                          heading={heading}
                                          setFilters={f => {
                                            setPage(1);
                                            setFilters(f);
                                          }}
                                          filters={filters}
                                          className={heading.className}
                                        />
                                      );
                                    }
                                    if(heading.show) {
                                        return (
                                            <FilterHeading
                                                key={heading.label}
                                                heading={heading}
                                                setFilters={f => {
                                                    setPage(1);
                                                    setFilters(f);
                                                }}
                                                filters={filters}
                                                className={heading.className}
                                                options={data.filter_list[heading.field]}
                                            />
                                        );
                                    }
                                  })}
                                {activeView === "hire" && (
                                    <th>
                                    <Button
                                      onClick={toggleSelectVisible}
                                      color={
                                        data.results.find(
                                          part =>
                                            Object.keys(selected).indexOf(part.id.toString()) === -1
                                        )
                                          ? ""
                                          : "danger"
                                      }
                                    >
                                      {data.results.find(
                                        part =>
                                          Object.keys(selected).indexOf(part.id.toString()) === -1
                                      ) ? (
                                        <div>
                                          T
                                          <span>Visible</span>
                                        </div>
                                      ) : (
                                        <div>
                                          X
                                          <span>Visible</span>
                                        </div>
                                      )}
                                    </Button>
                                    </th>
                                )}
                                {!!Object.entries(selected).length && activeView === "hire" && (
                                    <th>
                                        <Button onClick={() => setSelected({})} color="danger">
                                            X
                                        </Button>
                                    </th>
                                )}
                            </tr>
                         </thead>
                         <tbody>
                            {data.results.map((invoice, index) => (
                                <InvoiceRow
                                    index={index}
                                    invoice={invoice}
                                    onChange={onChange}
                                    onSave={onSave}
                                    onDelete={onDelete}
                                    onApprove={onApprove}
                                    showApproved={view === "approved"}
                                    onReady={onReady}
                                    setSelectedInvoice={setSelectedInvoice}
                                    setCreditModalOpen={setCreditModalOpen}
                                    onNominalChange={onNominalChange}
                                    codes={codes}
                                    activeView={activeView}
                                    trackingOptions={trackingOptions}
                                    onTrackingOptionChange={onTrackingOptionChange}
                                    onPartList={onPartView}
                                    selected={Object.keys(selected).indexOf(invoice.id.toString()) !== -1}
                                    onSelectCheck={onSelectCheck}
                                    onCheckClear={clearSelected}
                                    onRowDetailSelect={onHireView}
                                    onHide={onHide}
                                />
                            ))}
                         </tbody>
                     </Table>
                     <PaginationWrapper
                        setPage={setPage}
                        page={page}
                        dataCount={Math.ceil(data.count / 25)}
                     ></PaginationWrapper>
                 </Column>
                </Columns>
            </Box>
            {activeView === "hire" && (view === "ready" || view === "not_approved") &&
            <Box>
                <Columns isMultiline>
                    <Column>
                        <Button
                            color={"success"}
                            onClick={e => setApprovalModalOpen(true)}
                            isFullWidth
                        >
                            {view === "ready" ? "Approve Selected" : "Ready To Approve Selected"}
                        </Button>
                    </Column>
                </Columns>
            </Box>
            }
            <PartListModal
                partOrder={selectedPartOrder}
                show={partListModalOpen}
                setShow={setPartListModalOpen}
            />
            {selectedInvoice &&
                <CreateCreditNoteModal
                    autoFill={{customer: selectedInvoice.customer, invoice: selectedInvoice}}
                    endpoint={props.endpoint}
                    dataFresh={dataFresh}
                    open={creditModalOpen}
                    setOpen={setCreditModalOpen}
                />
            }
            {selected && activeView === "hire" &&
            <ApprovalModal
                invoices={selected}
                open={approvalModalOpen}
                setOpen={setApprovalModalOpen}
                setSelected={setSelected}
                onSave={onSave}
                trackingOptions={trackingOptions}
                nominalCodes={codes}
                nominalObjects={codeObjects}
                trackingObjects={trackingOptionObjects}
                onApprove={onApprove}
                view={view}
                onReadyToApprove={onReady}
            />
            }
            {activeView === "hire" &&
                <RentalInfoModal
                    data={rental}
                    open={detailModalOpen}
                    setOpen={setDetailModalOpen}
                    loaded={(!!rental)}
                />
            }
        </div>
    );


}